/**
 * Access Control API service
 * Menu visibility = Access Control; Functionality = User Role
 */
import axiosInstance from './AxiosInstance';

const BASE = '/access-control';

export const accessControlService = {
  getMyAccess: () => axiosInstance.get(`${BASE}/my-access`),
  getMenuSections: () => axiosInstance.get(`${BASE}/menu-sections`),
  getRoleAccess: (roleId) => axiosInstance.get(`${BASE}/role/${roleId}`),
  getUserAccess: (corporateUserId) => axiosInstance.get(`${BASE}/user/${corporateUserId}`),
  saveUserAccess: (corporateUserId, { menuSectionIds, fullAccess }) =>
    axiosInstance.put(`${BASE}/user/${corporateUserId}`, { menuSectionIds, fullAccess }),
};
